// extracted by mini-css-extract-plugin
export default {"thanks":"FH3cwxWIL1vNE2lNaLYl","title":"p8nlaUeVX5vWfFkc8f7d","body":"g2yL1aFLxrePyOSa52C_","another":"BP5JNq0QH8kfrw_w5O5C"};